import React, { useEffect, useRef, useState } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import Modal from '@mui/material/Modal';
import { jsonEditorStyles } from './jsonEditorStyles';
import cn from 'clsx';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import GenerateSignInUI from './componentUI/signInComponent';
import GenerateAADReadUI from './componentUI/aadReadComponent';
import GenerateAADUpdateUI from './componentUI/aadUpdateComponent';
import GenerateAADCreateUI from './componentUI/aadCreateComponent';
import GenerateConditionalUI from './componentUI/conditionalComponent';
import GenerateUsernamePasswordValidationUI from './componentUI/usernamePasswordValidation';
import GenerateUserInputPageUI from './componentUI/userInputPageComponent';
import GenerateRestAPIUI from './componentUI/restAPIComponent';
import GenerateValidateMagicLinkUI from './componentUI/validateMagicLink';
import GenerateTokenIssuerUI from './componentUI/tokenIssuer';
import GenerateGoogleComponentUI from './componentUI/googleComponent';
import GenerateMFAAuthComponent from './componentUI/mfaAuthComponent';
import GenerateWebAuthnRegistrationUI from './componentUI/webAuthnRegistrationComponent';
import JSON_CONSTANTS from '../../constants/jsonConstants';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import SaveIcon from '@mui/icons-material/Save';
import { useDispatch } from 'react-redux';
import { updateNodeLabel } from '../../store';
import { TextField, FormControl, styled } from '@mui/material';
import GenerateWebAuthnAuthenticationUI from './componentUI/webAuthnAuthenticationComponent';
import GenerateWebAuthnCredentialsExistUI from './componentUI/webAuthnCredentialsExist';
import GenerateWebAuthnAvailabilityUI from './componentUI/webAuthnAvailabilityComponent';
import GenerateConditionalAccessEvaluationUI from './componentUI/conditionalAccessEvaluationComponent';
import GenerateConditionalAccessRemediationUI from './componentUI/conditionalAccessRemediationComponent';
import GenerateErrorPageUI from './componentUI/errorPageComponent';
import AppInsightsComponentUI from './componentUI/appInsightsComponent';
import GenerateAuthorizeTokenUI from './componentUI/authorizeTokenComponent';
import GenerateSendEmailOTPUI from './componentUI/sendEmailOTPComponent';
import { GenerateSessionExistsUI } from './componentUI/sessionExistsComponent';
import { GenerateOIDCIdPUI } from './componentUI/oidcIdpComponent';
import { GenerateSAMLIdPUI } from './componentUI/samlIdPComponent';
import GenerateValidationErrorUI from './componentUI/validationErrorComponent';
import GenerateSetClaimsComponentUI from './componentUI/setClaimsComponent';
import { AdditionalComponentProps, getEditNodeComponentsMap} from './additionalNodes';


const WhiteBorderTextField = styled(TextField)`
  & .MuiInputBase-input {
    color: white;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: white;
    }
  }
`;

interface GritComponentProps {
  data: any;
  label: any;
  closeGritComponent: any;
  openSubFlowFC?: any;
}


const GritComponent = ({ data, label, closeGritComponent, openSubFlowFC }: GritComponentProps) => {
  const ComponentMap = getEditNodeComponentsMap();
  const classes: any = jsonEditorStyles();
  const [savedChanges, setSavedChanges] = useState<boolean>(false);
  const [editLabel, setEditLabel] = useState<string>('');
  const [labelName, setLabelName] = useState<string>(label);
  const dispatch = useDispatch();

  const id = 'text-' + Math.floor(Math.random() * 10000000);
  const style = { margin: 1, width: '500px' };
  const ref = useRef<null | ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    setLabelName(label);
  }, [label]);

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          closeGritComponent(null);
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.modalStyle}
    >
      <div className={classes.popup}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>
            {editLabel === '' && labelName}
            {editLabel !== '' && (
              <FormControl sx={style} required={data.required}>
                <WhiteBorderTextField
                  id={id}
                  label={data.label}
                  variant="outlined"
                  size="small"
                  value={labelName}
                  type="textbox"
                  onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setLabelName(event.target.value);
                    if (ref.current) clearTimeout(ref.current);
                    ref.current = setTimeout(() => {
                      setLabelName(event.target.value);
                    }, 500);
                  }}
                />
              </FormControl>
            )}
            {editLabel === '' && (
              <ModeEditOutlineSharpIcon
                onClick={() => {
                  setEditLabel(data['id']);
                }}
                className={classes.icon}
                color="secondary"
              />
            )}
            {editLabel !== '' && (
              <SaveIcon
                onClick={() => {
                  dispatch(updateNodeLabel({ id: editLabel, value: labelName }));
                  setEditLabel('');
                }}
                className={classes.icon}
                color="secondary"
              />
            )}
            {/* Component Type: {data['componentType']} */}
          </div>
          <div>
            <ClearOutlinedIcon
              onClick={() => {
                if (!savedChanges) {
                  if (!window.confirm(JSON_CONSTANTS.unsavedComponentCloseMsg)) {
                    return;
                  }
                }
                closeGritComponent(null);
              }}
              className={classes.delete}
            />
          </div>
        </div>

        <div className={cn(classes.flexRow, classes.policyBody)}>
          {data['componentType'] === 'signIn' && (
            <GenerateSignInUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              openSubmitActionFC={(data: any) => openSubFlowFC(data, 'formSubmitAction')}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'google' && (
            <GenerateGoogleComponentUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'aadRead' && (
            <GenerateAADReadUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'aadUpdate' && (
            <GenerateAADUpdateUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'aadCreate' && (
            <GenerateAADCreateUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'conditionals' && (
            <GenerateConditionalUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'usernamePasswordValidation' && (
            <GenerateUsernamePasswordValidationUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'userInputPage' && (
            <GenerateUserInputPageUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              openSubmitActionFC={(data: any) => openSubFlowFC(data, 'formSubmitAction')}
              openCustomEmailFC={(data: any) => openSubFlowFC(data, 'emailVerificationSendAction')}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'appInsights' && (
            <AppInsightsComponentUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}

          {data['componentType'] === 'restAPI' && (
            <GenerateRestAPIUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'validateMagicLink' && (
            <GenerateValidateMagicLinkUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'webAuthnRegistration' && (
            <GenerateWebAuthnRegistrationUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'webAuthnAuthentication' && (
            <GenerateWebAuthnAuthenticationUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'webAuthnAvailability' && (
            <GenerateWebAuthnAvailabilityUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'webAuthnCredentialsExist' && (
            <GenerateWebAuthnCredentialsExistUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'tokenIssuer' && (
            <GenerateTokenIssuerUI
              isUserInfoEndpoint={false}
              componentData={data}
              closeGritComponent={closeGritComponent}
              openUserInfoEndpointFC={(data: any) => openSubFlowFC(data, 'userInfoEndpoint')}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'userInfoIssuer' && (
            <GenerateTokenIssuerUI
              isUserInfoEndpoint={true}
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'authorizeToken' && (
            <GenerateAuthorizeTokenUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'mfa' && (
            <GenerateMFAAuthComponent
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'conditionalAccessEvaluation' && (
            <GenerateConditionalAccessEvaluationUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'conditionalAccessRemediation' && (
            <GenerateConditionalAccessRemediationUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'errorPage' && (
            <GenerateErrorPageUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'sendEmailOTP' && (
            <GenerateSendEmailOTPUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'sessionExists' && (
            <GenerateSessionExistsUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'oidcIdP' && (
            <GenerateOIDCIdPUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'samlIdP' && (
            <GenerateSAMLIdPUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'validationError' && (
            <GenerateValidationErrorUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {data['componentType'] === 'setClaims' && (
            <GenerateSetClaimsComponentUI
              componentData={data}
              closeGritComponent={closeGritComponent}
              setUnsavedChanges={(savedChanges: boolean) => {
                setSavedChanges(savedChanges);
              }}
            />
          )}
          {
            Object.keys(ComponentMap).find(name => name === data['componentType'])? 
              <>{
                ComponentMap[data['componentType']]({
                  data, closeGritComponent, 
                  setUnsavedChanges: (saveChanges: boolean) => { setSavedChanges(saveChanges) }
                })
              }</>
              : 
              <></>
          }
        </div>
      </div>
    </Modal>
  );
};

// export default withAITracking(reactPlugin, GritComponent);
export default GritComponent;
